import { useTrackingQuery } from './use-tracking-query';
export function useNotificationActive() {
  var _useTrackingQuery$dat, _useTrackingQuery$dat2;

  return (_useTrackingQuery$dat = (_useTrackingQuery$dat2 = useTrackingQuery().data) === null || _useTrackingQuery$dat2 === void 0 ? void 0 : _useTrackingQuery$dat2.isNotificationActive) !== null && _useTrackingQuery$dat !== void 0 ? _useTrackingQuery$dat : true;
}